<template>
        <FlyerlineModal ref="modal" @close="handleClose" name="addressBookUpdateAddress">
            <!-- type 2 = lieferadresse -->
            <SkyFormLoader v-if="addresskey" :key="addresskey" formName="prj_shopupdateaddress"
                           :params="{shop_addressKey: addresskey, shop_addressKeyType: 2}"
                           @success="handleConfirm"/>
        </FlyerlineModal>
</template>

<script>
    import ComponentPromise from "mixins/ComponentPromise";
    import FlyerlineModal from "fragments/FlyerlineModal";
    import SkyFormLoader from "fragments/SkyFormLoader";

    export default {
        name: "AddressBookUpdateAddress.vue",
        components: {FlyerlineModal, SkyFormLoader},
        mixins: [ComponentPromise],
        data() {
            return {addresskey: ""}
        },
        methods: {
            /**
             * @param key for form request
             */
            open(key) {
                this.addresskey = key
                this.$refs.modal.open()
                return this.createPromise()
            },
            handleConfirm(data) {
                this.resolver(data)
                this.$refs.modal.close()
            },
            handleClose() {
                // Ensure reloading form if at next open() the same key is given
                this.addresskey = ""
                this.rejectOldPromise('Window Closed without Confirmation')
            }
        }
    }
</script>

<style scoped>

</style>